import React, { useState, useEffect } from "react";
import "./Login.css";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import Alerts from "../Assets/Alerts";
import Loader from "../Assets/Loader";
import { getData } from "../../FetchApiServices";
import { useDispatch, useSelector } from "react-redux";
import { addUser, deleteUser } from "../../react-redux/Slicer/userSlice";
import moment from "moment";
import PlotOsButton from "./PlotOsButton";
// Same brand mark the sidebar and the product switcher use.
import t2tLogo from "../../assets/plot-os/t2t.svg";

export const Header = () => {
  return (
    <div>
      <img
        src={process.env.PUBLIC_URL + "/img/bg.png"}
        className="bg_img d-none d-lg-block"
        alt=""
      />
      <div className="container-fluid pt-4">
        <header id="loginheader" className="pb-4 pb-lg-0">
          <div className="d-flex align-items-center gap-1">
            <img
              src={process.env.PUBLIC_URL + "/logo/Jindal.png"}
              className="img-fluid"
              alt=""
              width={100}
            />
            <img
              src={process.env.PUBLIC_URL + "/logo/Sohar.png"}
              className="img-fluid border-start border-secondary-subtle"
              alt=""
              width={100}
            />
          </div>
        </header>
      </div>
    </div>
  );
};

export const Footer = () => {
  return (
    <div>
      <footer className="text-center pbo-logo">
        <img
          src={process.env.PUBLIC_URL + "/img/pbo.png"}
          className="pt-4 pb-1"
          alt=""
        />
        <p>© {new Date().getFullYear()} PBOPlus Consulting all rights reserved.</p>
      </footer>
    </div>
  );
};

export const ForgetPassword = ({ setShowForgetPassword }) => {
  return (
    <>
      <form method="post" action="#" autoComplete="off">
        <div className="forgotpassword">
          <div className="form-signin mt-5">
            <div className="text-center">
              <img
                className="img-responsive center-block py-1"
                src={process.env.PUBLIC_URL + "/logo/plotnew.png"}
                alt=""
                style={{ width: "80px" }}
              />
            </div>

            <div className="forgettab">
              <div id="forgotpassword" className="tab-pane active">
                <label
                  htmlFor="username"
                  className="form-check-label mb-1 ft-9"
                >
                  Enter your email
                </label>
                <input
                  type="email"
                  name="username"
                  placeholder="Enter Your Email"
                  className="form-control mt-1 form-control-sm"
                  required="required"
                  autoComplete="off"
                  style={{ fontSize: "15px" }}
                />

                <div className="curve_btn green_btn text-center mt-1">
                  <button className="submit btn-lg" type="submit">
                    Submit
                  </button>
                </div>

                {/* 👇 Back to Login Button */}
                <div className="text-start mt-3">
                  <Link
                    to=""
                    className="ft-89 text-success"
                    onClick={() => setShowForgetPassword(false)}
                  >
                    ← Back to Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div className="powered ft-9">Powered by PBOPlus Consulting services</div>
    </>
  );
};

ForgetPassword.propTypes = {
  setShowForgetPassword: PropTypes.func.isRequired,
};

// T2T-only login. OSIF has been separated out — this app authenticates T2T
// users exclusively (always sends is_t2t and routes to the T2T module).
const Login = () => {
  let navigate = useNavigate();
  const [checkbox, setCheckbox] = useState(true);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.users[0]);

  useEffect(() => {
    if (user) {
      // Single T2T module — always land on the T2T home.
      navigate("/t2t-home");
    }
  }, [user, navigate]);

  useEffect(() => {
    if (alert.message) {
      const timer = setTimeout(() => {
        setAlert({ type: "", message: "" });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  // Surface a Plot OS SSO failure that redirected back here (?sso_error=…).
  useEffect(() => {
    const err = new URLSearchParams(window.location.search).get("sso_error");
    if (!err) return;
    const messages = {
      no_account: "No T2T account matches your Plot OS identity. Please contact your administrator.",
      inactive: "Your T2T account is inactive. Please contact your administrator.",
      replayed: "That sign-in link was already used. Please sign in again.",
      sso_failed: "Plot OS sign-in failed or the link expired. Please try again.",
      sso_disabled: "Plot OS sign-in is not enabled.",
      missing_code: "The Plot OS sign-in link was invalid. Please try again.",
      missing_token: "Plot OS sign-in did not complete. Please try again.",
    };
    setAlert({ type: "error", message: messages[err] || "Plot OS sign-in failed. Please try again." });
    window.history.replaceState(null, "", window.location.pathname); // clean the URL
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!checkbox) {
      setAlert({
        type: "warning",
        message: "Please accept the Terms of Use and Privacy Policy to continue",
      });
      return;
    }
    const email = e.target.username.value;
    const password = e.target.password.value;
    const current_date = moment().format("YYYY-MM-DD");
    const current_time = moment().format("HH:mm:ss");
    const formData = {
      email,
      password,
      current_date,
      current_time,
      is_t2t: true,
    };

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();
      if (result.status === 200) {
        // Clear previous session data
        localStorage.clear();
        dispatch(deleteUser());

        // Mark this session as a T2T login for route guards.
        localStorage.setItem("login_type", "t2t");

        const { token, user_id } = result.data || {};

        // Set token in Redux (this will sync to localStorage via reducer)
        if (token) {
          dispatch({ type: "user/setToken", payload: token });
        }

        setAlert({ type: "success", message: result.message });

        // Store refresh token if provided
        if (result.data?.refreshToken) {
          localStorage.setItem("refreshToken", result.data.refreshToken);
        }

        // Fetch user data and navigate into the T2T module
        try {
          const userResp = await getData(`users/${user_id}`);

          if (userResp && userResp.data && userResp.data.data) {
            const raw = userResp.data.data;
            const userData = Array.isArray(raw) ? raw[0] : raw;
            dispatch(addUser(userData));
            navigate("/t2t-home");
            setLoading(false);
            return;
          }
        } catch (error) {
          console.error("Failed to fetch user data:", error);
          setAlert({ type: "error", message: "Failed to fetch user data" });
        }

        // Fallback navigation
        navigate("/t2t-home");
      } else {
        setAlert({ type: "error", message: result.error || "Login failed" });
      }
      setLoading(false);
    } catch (error) {
      setAlert({ type: "error", message: "Internal Server Error" });
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      {showForgetPassword ? (
        <ForgetPassword setShowForgetPassword={setShowForgetPassword} />
      ) : (
        <div className="login">
          {loading && <Loader />}
          {alert.message && (
            <Alerts type={alert.type} message={alert.message} />
          )}
          <Header />
          <div className="col-lg-6 col-xl-8 col-md-12 pt-3">
            <div className="row">
              <div className="col-xl-6 mx-auto">
                <div id="form-area">
                  <div className="card p-3 shadow-sm border-light-subtle login-card">
                    {/* T2T branding */}
                    <div className="t2t-logo mb-3 text-center">
                      <img src={t2tLogo} alt="" className="t2t-mark" />
                      <h2 className="t2t-title">T<span>2</span>T</h2>
                      <p className="t2t-subtitle">TABLE TO TABLE</p>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Username</label>
                        <input
                          type="text"
                          name="username"
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="user@t2t.com"
                          required="required"
                          style={{ fontSize: "16px" }}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <div className="input-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder="Password"
                            className="form-control"
                            id="exampleInputPassword1"
                            required="required"
                            style={{ fontSize: "16px" }}
                          />
                          <button
                            type="button"
                            className="position-absolute top-50 end-0 translate-middle btn btn-link p-0"
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label="Toggle password visibility"
                          >
                            <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} fs-6`}></i>
                          </button>
                        </div>
                      </div>
                      <div className={`form-check mt-2 ${!checkbox && "text-danger"}`}>
                        <label className="form-check-label ft-8 mb-0" htmlFor="t&c">
                          <input
                            type="checkbox"
                            onChange={(e) => setCheckbox(e.target.checked)}
                            checked={checkbox}
                            name="t&c"
                            className="form-check-input"
                            id="t&c"
                          />
                          <span>
                            {" "}I confirm that I have read, consent and agree to T2T&#39;s{" "}
                            <Link to="/terms-and-condition" target="_blank">Terms of Use</Link>{" "}
                            and{" "}
                            <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>.
                          </span>
                        </label>
                        {!checkbox && (
                          <p className="text-danger ft-7">
                            Please accept the Terms of Use and Privacy Policy to continue
                          </p>
                        )}
                      </div>
                      <button type="submit" className="btn btn-success mt-2 m-0 w-100" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                      </button>
                      <div className="mt-1">
                        <Link to="" onClick={() => setShowForgetPassword(true)} style={{ fontSize: "14px" }}>
                          Forgot your Password?
                        </Link>
                      </div>
                      <PlotOsButton />
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
